import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'

document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('react-root')
  if (!container) throw new Error('Root element not found')
  const root = createRoot(container)
  root.render(<App />)
})
